import axios from "axios";
import * as type from "./ActionType";

export const loginAPI = ()  => {
  return {type: type.LOGIN_SUCCESS}
   
};

